import DayGridScenario from '../schema/DayGridScenario';
import getStore from '../store';
import { SchedulingGridViewStateHost } from 'owa-calendar-scheduling-grid';

export default function getScenarioStore(scenario: DayGridScenario): SchedulingGridViewStateHost {
    return getStore().scenarios.get(scenario);
}
